module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_6005.5ecd0760.png";